module.exports = __webpack_public_path__ + "static/media/more-icon.4dec57e9.svg";